module.exports = __webpack_public_path__ + "img/mini-028.7445ca28.jpg";